import { AbstractControl, ValidatorFn } from '@angular/forms';

export function forbiddenName(): ValidatorFn {
  const regex = /[~`!#$@%^&*()+=\-_{}\[\]|\\:;"'<,>?]/;
  return (control: AbstractControl): {[key: string]: any} | null => {
    const forbidden = regex.test(control.value);
    return forbidden ? {'forbiddenName': {value: control.value}} : null;
  };
}